module.exports = __webpack_public_path__ + "img/Selina.bb9d69dc.jpg";